export const getSelectionSearchStatus = ({
  query,
  searchedQuery,
  loading,
  failed,
  resultCount,
  selected,
}) => {
  if (selected) return 'selected';
  if (String(query || '').length <= 2) return 'idle';
  if (loading || searchedQuery !== query) return 'loading';
  if (failed) return 'error';
  return resultCount > 0 ? 'results' : 'empty';
};
